/**
 * Image preview dialog component (reusable)
 */
import React from 'react';
import { Dialog, DialogContent } from '../ui/dialog';

const ImagePreviewDialog = ({ imageUrl, onClose }) => {
  return (
    <Dialog open={!!imageUrl} onOpenChange={onClose}>
      <DialogContent className="max-w-3xl p-2 sm:p-4">
        <img
          src={imageUrl}
          alt="Preview"
          className="w-full h-auto max-h-[80vh] object-contain rounded-lg"
        />
      </DialogContent>
    </Dialog>
  );
};

export default ImagePreviewDialog;
